interface AttributeReviewRowChipsProps {
  chips: string[];
}

export function AttributeReviewRowChips({
  chips,
}: AttributeReviewRowChipsProps) {
  return (
    <>
      {chips.map((chip) => (
        <span
          key={chip}
          className="inline-flex items-center rounded-md border border-slate-200 bg-slate-50 px-1.5 py-0.5 text-xs font-semibold text-slate-700 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-200 flex-shrink-0"
        >
          {chip}
        </span>
      ))}
    </>
  );
}
